const { TextField } = window.Edocat.Components;

import { ControlInterface } from '../../types/FormJson';

export default class NumberRange extends React.PureComponent<ControlInterface> {
	onMinChange = (event: React.ChangeEvent) => {
		const { onChange, name, dirty } = this.props;
		onChange([name, 'value', 'min'], (event.target as HTMLInputElement).value, dirty);
	};

	onMaxChange = (event: React.ChangeEvent) => {
		const { onChange, name, dirty } = this.props;
		onChange([name, 'value', 'max'], (event.target as HTMLInputElement).value, dirty);
	};

	render() {
		const { label, disabled, value, mandatory, name, className, error } = this.props;

		return (
			<div className={`form-row row-${name}`}>
				<TextField
					className={`Number-Range-Input Number-Range-Min ${className}`}
					disabled={disabled}
					error={error}
					id={name}
					label={label}
					mandatory={mandatory}
					name={name}
					onChange={this.onMinChange}
					type="number"
					value={value.min || ''}
					InputProps={{ max: value.max }}
				/>
				<TextField
					className={`Number-Range-Input Number-Range-Max ${className}`}
					disabled={disabled}
					id={name}
					mandatory={mandatory}
					name={name}
					onChange={this.onMaxChange}
					type="number"
					value={value.max || ''}
					InputProps={{ min: value.min }}
				/>
			</div>
		);
	}
}
